import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';
import isEqual from 'react-fast-compare';

import {
  MELTING_TEMP_INITIAL_PREFERENCES_DNA,
  MELTING_TEMP_INITIAL_PREFERENCES_RNA,
  MELTING_TEMP_PREFERENCES_PRIMER3_DEFAULTS,
  MeltingTempPreferences,
  NucleotideType,
} from 'biojs/BioConstants';
import Link from 'ui-library/Link';

interface MeltingTempDefaultsProps {
  meltingTempOptions: MeltingTempPreferences;
  nucleotideType: NucleotideType;
  setMeltingTempOptions: (prefs: MeltingTempPreferences) => void;
}

export default function MeltingTempModalDefaults({
  meltingTempOptions,
  nucleotideType,
  setMeltingTempOptions,
}: MeltingTempDefaultsProps): JSX.Element {
  return (
    <div className={classNames(['row set-defaults', css(styles.defaults)])}>
      <div className="col col-md-6">
        {nucleotideType === NucleotideType.DNA && (
          <Link
            disabled={isEqual(meltingTempOptions, MELTING_TEMP_PREFERENCES_PRIMER3_DEFAULTS)}
            onClick={() => {
              setMeltingTempOptions(MELTING_TEMP_PREFERENCES_PRIMER3_DEFAULTS);
            }}
          >
            Set to Primer3 defaults
          </Link>
        )}
      </div>
      <div className="col col-md-6 text-right">
        <Link
          disabled={isEqual(
            meltingTempOptions,
            nucleotideType === NucleotideType.RNA
              ? MELTING_TEMP_INITIAL_PREFERENCES_RNA
              : MELTING_TEMP_INITIAL_PREFERENCES_DNA
          )}
          onClick={() => {
            setMeltingTempOptions(
              nucleotideType === NucleotideType.RNA
                ? MELTING_TEMP_INITIAL_PREFERENCES_RNA
                : MELTING_TEMP_INITIAL_PREFERENCES_DNA
            );
          }}
        >
          Reset to defaults
        </Link>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  defaults: {
    marginTop: '10px',
  },
});
